import React from 'react';
import cn from 'classnames';
import ArrowDropUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import Theme from 'styles/theme';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';

export default class ArrowIconToggle extends React.PureComponent {
  getSortIndicator(sortDirection) {
    if (sortDirection === null) {
      return null;
    }
    const dir = sortDirection === 'asc' ? 'up' : 'down';
    if (dir === 'up') {
      return <ArrowDropUp color={Theme.palette.darkerGrey} />;
    }

    return <ArrowDropDown color={Theme.palette.darkerGrey} />;
  }

  render() {
    const {sortDirection, ...props} = this.props;
    return (
      <div {...props} className={cn('sort-indicator', this.props.className)}>
        {this.getSortIndicator(sortDirection)}
      </div>
    );
  }
}
